import React from 'react';
import { Typography } from '@material-ui/core';
import Attribute from '../../../interfaces/attribute';
import ConfirmDialog, { IConfirmDialogProps } from './ConfirmDialog';

type Props = Omit<IConfirmDialogProps, 'title' | 'body'> & { attribute: Partial<Attribute> };

const NewConfirmDialog = ({
  open,
  onClose,
  attribute,
  onSubmit,
}: Props) => (
  <ConfirmDialog
    title="Add New Attribute"
    body={<Contents {...attribute} />}
    open={open}
    onClose={onClose}
    onSubmit={onSubmit}
  />
);

function Contents(attribute: Partial<Attribute>) {
  return (
    <>
      <Typography variant="body1">
        You are creating{' '}
        {
          <span
            style={{
              fontWeight: 'bold',
            }}
          >
            “{attribute.name}”
          </span>
        }
        , once added:{' '}
        <ul>
          <li>Attribute name cannot be changed</li>
          <li>
            Countries and regions cannot be removed, though they can be added
          </li>
          <li>The attribute type cannot be changed</li>
          {!attribute.isToggle && (
            <li>Options cannot be removed, though they can be added</li>
          )}
          {!!attribute.hasTrainingSystemAccess && (
            <li>Training System Access can be enabled but not disabled</li>
          )}
          {!!attribute.isGeneralAttribute && (
            <li>Logs & Operations Access can be enabled but not disabled</li>
          )}
        </ul>
      </Typography>
      <br></br>
      <Typography variant="body1">
        Would you like to continue and add this new attribute?
      </Typography>
    </>
  );
}

export default NewConfirmDialog;
